import { useEffect, useRef, useState } from 'react';

const useInView = (options?: IntersectionObserverInit) => {
  const [isInView, setIsInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      const { isIntersecting, intersectionRatio } = entry;
      const isInViewport =
        typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;

      setIsInView(isInViewport);
    }, options);

    if (ref.current) {
      observer.observe(ref.current!);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current!);
      }
    };
  }, [ref.current, options]);

  return { isInView, ref };
};

export default useInView;
